import { useTheme } from "@mui/system";

import { ThemeType } from "theme/types";

export const useTypedTheme = () => {
  const theme = useTheme<ThemeType>();

  return {
    theme,
  };
};
